import classNames from 'classnames'

export interface FlexRowProps {
    className?: string
    children?: React.ReactNode
    gap?: number
    wrap?: boolean
    horizontal?: 'center' | 'space-between'
    vertical?: 'center' | 'flex-end' | 'baseline'
    top?: number
    bottom?: number
    maxWidth?: number
}

export const FlexRow = (props: FlexRowProps) => (
    <div
        className={classNames(props.className, 'flex-row')}
        style={{
            gap: props.gap ? props.gap * 8 : undefined,
            justifyContent: props.horizontal,
            alignItems: props.vertical,
            flexWrap: props.wrap ? 'wrap' : undefined,
            paddingTop: props.top ? props.top * 8 : undefined,
            paddingBottom: props.bottom ? props.bottom * 8 : undefined,
            maxWidth: props.maxWidth ? `${props.maxWidth}px` : undefined,
        }}
    >
        {props.children}
    </div>
)
